"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var PreLoaderDirective = (function () {
    function PreLoaderDirective(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
    }
    PreLoaderDirective.prototype.ngAfterViewInit = function () {
        var r = this._renderer;
        var ele = this._el.nativeElement;
        r.setElementClass(ele, 'preloader', true);
        r.setElementClass(ele, 'pl-xxl', true);
        var svg = r.createElement(ele, 'svg');
        r.setElementClass(svg, 'pl-circular', true);
        r.setElementAttribute(svg, 'viewBox', '25 25 50 50');
        var circle = r.createElement(svg, 'circle');
        r.setElementClass(circle, 'plc-path', true);
        r.setElementAttribute(circle, 'cx', '50');
        r.setElementAttribute(circle, 'cy', '50');
        r.setElementAttribute(circle, 'r', '20');
    };
    return PreLoaderDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PreLoaderDirective.prototype, "preLoader", void 0);
PreLoaderDirective = __decorate([
    core_1.Directive({ selector: '[bwPreloader]' }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
], PreLoaderDirective);
exports.PreLoaderDirective = PreLoaderDirective;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/preloader/preloader.directive.js
// module id = 114
// module chunks = 0